import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Fade from '@material-ui/core/Fade';
import InputSelect from './InputSelect';
import SortDownIcon from './icons/SortDown';

import { AVAILABILITY_MODE, QUOTE_ONLY_MODE } from './constants';
import { useBuilderStore } from './store';
import { isUndefined } from 'lodash';

const useStyles = makeStyles({
  root: {},
});

const options = [
  {
    label: 'Show All Dates',
    key: AVAILABILITY_MODE,
  },
  {
    label: 'Quote Only',
    key: QUOTE_ONLY_MODE,
  },
];

const QuoteModeSelector = () => {
  const classes = useStyles();
  const date = useBuilderStore(state => state.data.date);
  const showAvailability = !isUndefined(date);
  const quoteMode = useBuilderStore(state => state.data.quoteMode);
  const setQuoteMode = useBuilderStore(state => state.actions.setQuoteMode);
  const text = useMemo(() => options.find(o => o.key === quoteMode)?.label, [quoteMode]);
  return (
    <Fade in={showAvailability}>
      <div className={classes.root}>
        <InputSelect
          text={text}
          value={quoteMode}
          onChange={setQuoteMode}
          adornment={<SortDownIcon />}
          options={options}
          label="availability selector"
        />
      </div>
    </Fade>
  );
};

export default QuoteModeSelector;
